import React, { useState } from 'react';
import Card from './Card.js';

export default function DropZone({ card, onDrop, label, cardSize = 1, isEmpty = false }) {
  const [dragOver, setDragOver] = useState(false);

  const w = Math.round(60 * cardSize);
  const h = Math.round(84 * cardSize);

  function handleDragOver(e) {
    e.preventDefault();
    setDragOver(true);
  }

  function handleDragLeave() {
    setDragOver(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    setDragOver(false);
    onDrop && onDrop();
  }

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={onDrop}
      style={{ position: "relative", cursor: "pointer" }}
    >
      {card ? (
        <div style={{
          outline: dragOver ? "2px solid #c9a84c" : "none",
          boxShadow: dragOver ? "0 0 20px rgba(201,168,76,0.6)" : "none",
          borderRadius: "6px",
          transition: "all 0.15s ease",
        }}>
          <Card card={card} cardSize={cardSize} disabled />
        </div>
      ) : (
        <div style={{
          width: w + "px",
          height: h + "px",
          borderRadius: Math.round(6 * cardSize) + "px",
          border: dragOver
            ? "2px solid #c9a84c"
            : "2px dashed rgba(201,168,76,0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: dragOver ? "#c9a84c" : "rgba(201,168,76,0.3)",
          fontSize: Math.round(18 * cardSize) + "px",
          background: dragOver ? "rgba(201,168,76,0.1)" : "transparent",
          boxShadow: dragOver ? "0 0 20px rgba(201,168,76,0.4)" : "none",
          transition: "all 0.15s ease",
          cursor: "pointer",
        }}>
          {label || "A"}
        </div>
      )}
    </div>
  );
}
